import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import profile from '../reducers/profile';

let persistedState = {};
if (typeof window !== 'undefined') {
  try {
    const serialised = localStorage.getItem('reduxState');
    if (serialised) persistedState = JSON.parse(serialised);
  } catch {
    persistedState = {};
  }
}
const rootReducer = combineReducers({
  user: profile
});

const configureStore = () => {
  return createStore(
    rootReducer,
    persistedState,
    compose(applyMiddleware(thunk))
  );
};

export default configureStore;